export const getLastMonthDay1 = () => {
    const date = new Date();
    date.setDate(1);
    date.setMonth(date.getMonth() - 1);
    return date.toISOString();
};

export const getLastDayOfLastMonth = () => {
    const date = new Date();
    date.setDate(1);
    date.setDate(date.getDate() - 1);
    return date.toISOString();
};
